export const MealPlanDays = {
  bindings: {
    day: '<',
    days: '<',
    isSwapping: '<',
    isSwappingDay: '<',
    onUpdate: '&',
    onRemove: '&',
  },

  template: `
    <div class="meal-plan-days">
      <div class="d-flex border border-bottom pointer py-2"
        ng-class="{ 'bg-white': $ctrl.day === day.dayString }"
        ng-repeat="day in $ctrl.days track by $index"
        ng-click="$ctrl.onUpdate({ dayString: day.dayString })">
        <div class="mx-1 mx-md-2 text-center">
          <meal-plan-day-icon
            is-active="$ctrl.day === day.dayString"
            is-swapping="$ctrl.isSwapping && $ctrl.isSwappingDay === day.day"
            count="day.meals.length">
            {{ day.dayString | limitTo: 3 }}
          </meal-plan-day-icon>
        </div>
        <div class="d-none d-md-flex scroll-x">
          <div class="meal-plan-day-image pl-1 pointer"
            ng-repeat="meal in day.meals track by $index">
            <img
              ng-src="{{ meal.recipe.imageUrl.thumb | assetSrc }}"
              ng-click="$ctrl.onUpdate({ dayString: day.dayString })" />
            <i class="fa fa-minus-circle text-red"
              ng-click="$ctrl.onRemove({ mealId: meal.id, day: day.day })">
            </i>
          </div>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanDays.js